import { openDb, DB } from 'idb';
import { Base64 } from 'js-base64';

const storeName = 'keyval';

export default class KeyValueDb {
    public static async connect() {
        const db = await openDb('listory', 1, upgradeDB => {
            upgradeDB.createObjectStore(storeName);
        });

        return new KeyValueDb(db);
    }

    private db: DB;

    private constructor(db: DB) {
        this.db = db;
    }

    public async get(key) {
        return this.db
            .transaction(storeName)
            .objectStore(storeName)
            .get(key);
    }

    public async set(key, val) {
        const tx = this.db.transaction(storeName, 'readwrite');
        tx.objectStore(storeName).put(val, key);
        return tx.complete;
    }

    public async delete(key) {
        const tx = this.db.transaction(storeName, 'readwrite');
        tx.objectStore(storeName).delete(key);
        return tx.complete;
    }

    public async clear() {
        const tx = this.db.transaction(storeName, 'readwrite');
        tx.objectStore(storeName).clear();
        return tx.complete;
    }

    public async keys() {
        return this.db
            .transaction(storeName)
            .objectStore(storeName)
            .getAllKeys();
    }

    public async backup(): Promise<string> {
        try {
            const data = {};
            const keys = await this.keys();
            for (const key of keys) {
                if (key.startsWith('content')) continue;
                data[key] = await this.get(key);
            }

            const jsonString = JSON.stringify(data);
            const base64encoded = Base64.encode(jsonString);
            return base64encoded;
        } catch (error) {
            return '';
        }
    }

    public async restore(encodedJson: string) {
        try {
            const decodedJson = Base64.decode(encodedJson);
            const object = JSON.parse(decodedJson);
            for (const key of Object.keys(object)) {
                await this.set(key, object[key]);
            }
        } catch (error) {
            // Not much we can do here. Start a new life!
        }
    }
}
